import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {FixedSamplePoint} from "src/app/infrastructure/moovement-api/models/asset";

@Injectable({
  providedIn: 'root'
})
export class FixedSamplePointApiClient extends MoovementApiClient {



  create(assetToSync: FixedSamplePoint): Observable<FixedSamplePoint> {
    return this.httpClient.put<FixedSamplePoint>(`${this.baseUrl}/api/fixedSamplePoint`, assetToSync);
  }

  update(assetToSync: FixedSamplePoint): Observable<FixedSamplePoint> {
    return this.httpClient.post<FixedSamplePoint>(`${this.baseUrl}/api/fixedSamplePoint`, assetToSync);
  }
}
